/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  GetAuthConfigResponse,
  GetConfigResponse
} from './index.schemas';

import { useUnauthenticatedInstance } from '../staverton.openapi.axios';
import { useCustomInstance } from '../staverton.openapi.axios';





export const useGetAuthConfigHook = () => {
        const getAuthConfig = useUnauthenticatedInstance<GetAuthConfigResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getAuthConfig(
          {url: `/Config/AuthConfig`, method: 'GET', signal
    },
          );
        }, [getAuthConfig])
      }
    

export const getGetAuthConfigQueryKey = () => {
    return [`/Config/AuthConfig`] as const;
    }

    
export const useGetAuthConfigQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthConfigQueryKey();

  const getAuthConfig =  useGetAuthConfigHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>> = ({ signal }) => getAuthConfig(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthConfigQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>>
export type GetAuthConfigQueryError = unknown


export function useGetAuthConfig<TData = Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthConfig<TData = Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthConfig<TData = Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAuthConfig<TData = Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAuthConfigHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAuthConfigQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useGetConfigHook = () => {
        const getConfig = useCustomInstance<GetConfigResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getConfig(
          {url: `/Config/Create`, method: 'GET', signal
    },
          );
        }, [getConfig])
      }
    

export const getGetConfigQueryKey = () => {
    return [`/Config/Create`] as const;
    }

    
export const useGetConfigQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigQueryKey();

  const getConfig =  useGetConfigHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>> = ({ signal }) => getConfig(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>>
export type GetConfigQueryError = unknown


export function useGetConfig<TData = Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConfig<TData = Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetConfigHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetConfigQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



